import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { GroupsDuoIcon, SearchDuoIcon } from "@flat-ui";
import { useAppSelector } from "@store/store-helper";
import { searchSelector } from "@store/ui/ui-selector";
/** Empty page content for groups page */
export function GroupsEmptyPage(t0) {
  const $ = _c(4);
  const {
    isFiltering: t1
  } = t0;
  const isFiltering = t1 === undefined ? false : t1;
  const {
    debouncedSearchText
  } = useAppSelector(searchSelector);
  const {
    canCreateGroups
  } = useHasUserValidRoleCompanyLevel();
  if (isFiltering) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <EmptyPage title="No results found" subtitle="There are no groups that match the filters." icon={SearchDuoIcon} />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (debouncedSearchText.length) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <EmptyPage title="No results found" subtitle="There are no groups that match this search." icon={SearchDuoIcon} />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  } else {
    let t2;
    if ($[2] !== canCreateGroups) {
      t2 = <EmptyPage title="You don't have a group yet" subtitle={canCreateGroups ? <>You haven't added groups to your workspace. Select the "new group" button to create one.</> : <>You haven't added groups to your workspace.</>} icon={GroupsDuoIcon} />;
      $[2] = canCreateGroups;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
}